import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const handleSetupIntentError = async ({ userId, setupIntentId }: { userId: string; setupIntentId: string }) => {
  const response = await mutationExecute({
    variables: {
      userId,
      setupIntentId,
    },
    mutation: graphql(`
      mutation handleSetupIntentError($userId: String!, $setupIntentId: String!) {
        handleSetupIntentError(userId: $userId, setupIntentId: $setupIntentId)
      }
    `),
  });

  return response.data?.handleSetupIntentError ?? false;
};
